import {createContext} from 'react';

export const SyntheticContext = createContext({});
export const DateContext = createContext({});
export const ModuleContext = createContext({});
